import { ButtonList, DropdownButtonContext } from '@dixa/lib-shared-habla';
import { useContext } from 'react';

import { useCommands } from 'utils/commands';

import { KeyboardKeybindingsTableRowContext } from '../../../../../utils/keyboardKeybindingsTableRowContext';

export const UnassignKeybindingsItem = (): JSX.Element => {
  const { unassignKeybindings } = useCommands();
  const { closeDropdown } = useContext(DropdownButtonContext);
  const { enrichedCommand } = useContext(KeyboardKeybindingsTableRowContext);
  const {
    command: { name },
    canUnassignKeybindings,
  } = enrichedCommand;

  const handleClick = () => {
    unassignKeybindings(name);
    closeDropdown();
  };

  return (
    <ButtonList.Item isDisabled={!canUnassignKeybindings} onClick={handleClick}>
      Unassign
    </ButtonList.Item>
  );
};
